import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';
 
export interface GetJunoLogVars {
    s3Keys: String;
}
 
const GET_JUNO_LOGS= gql`
    query GetJunoLogs(
      $s3Keys: String
    ) {
        getJunoLogs(
          s3Keys: $s3Keys
        )
    }
`;
 
export const useGetJunoLogsQuery = () => {
    return useLazyQuery<AnyObject, GetJunoLogVars>(GET_JUNO_LOGS, {
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
    });
};